export function toInt(v: string | null, fallback: number) {
    const n = Number(v);
    return Number.isFinite(n) && n >= 0 ? n : fallback;
}

export function toLocalInput(dt?: string | null): string {
    if (!dt) return "";
    const d = new Date(dt);
    const pad = (n: number) => `${n}`.padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function localInputToUtcIso(local: string): string | null {
    if (!local) return null;
    const d = new Date(local);
    if (Number.isNaN(d.getTime())) return null;
    return d.toISOString();
}

export function nowLocalInputMin(): string {
    return toLocalInputValue(new Date());
}

export function toLocalInputValue(d: Date): string {
    const pad = (n: number) => n.toString().padStart(2, "0");
    const y = d.getFullYear();
    const m = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const h = pad(d.getHours());
    const min = pad(d.getMinutes());
    return `${y}-${m}-${day}T${h}:${min}`;
}